import { Component, OnInit, Input} from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { FormControl } from '@angular/forms';

interface Response extends Array<any> {}

@Component({
  selector: 'app-recupera-senha',
  templateUrl: './recupera-senha.component.html',
  styleUrls: ['./recupera-senha.component.scss']
})
export class RecuperaSenhaComponent implements OnInit {
  email: string;
  envioOk: boolean;
  erro: string;
  smallScreen: boolean;
  recuperandoLoading: boolean;

  @Input() stepper: any;
  emailControl = new FormControl();

  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private breakpointObserver: BreakpointObserver,
    private route: Router
  ) {
    breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small
    ]).subscribe(result => {
      this.smallScreen = result.matches;
    });
    this.recuperandoLoading = false;
   }

  ngOnInit() {
    this.envioOk = false;
  }

  onRecuperaSenhaClick() {
    this.recuperandoLoading = true;
    this.authService.recuperaSenha({ email: this.email })
      .subscribe((response: Response[any]) => {
        if (response && response.confirmation === 'success') {
          this.envioOk = true;
          this.erro = null;
          this.emailControl.setErrors(null);
        } else {
          this.emailControl.setErrors({incorrect: true});
          this.erro = 'Email não cadastrado.';
        }
        this.recuperandoLoading = false;
      },
      err => {
        window.alert(
          'Erro na solicitação, favor checar internet ou tentar novamente em alguns minutos.'
        );
        this.recuperandoLoading = false;
      }
    );
  }

  onVoltarClick() {
    this.stepper.previous();
  }

  onVoltarLogin() {
    this.route.navigate(['client/login']);
  }
}
